import script from "./ClosePosition.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosePosition.vue?vue&type=script&setup=true&lang=js"

import "./ClosePosition.vue?vue&type=style&index=0&id=76adde99&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76adde99"]])

export default __exports__